var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconRank1St = function SvgIconRank1St(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-rank-1st_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-1st_svg__b)",
    d: "M8.637 29.632c2.365.305 4.428 1.266 5.889 2.589.306.277.192 1.16-.175 1.35-1.749.908-3.988 1.313-6.353 1.007-2.365-.305-4.428-1.265-5.889-2.589-.306-.277-.192-1.159.174-1.35 1.75-.908 3.989-1.313 6.354-1.007Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-1st_svg__c)",
    d: "M8.637 29.632c2.365.305 4.428 1.266 5.889 2.589.306.277.192 1.16-.175 1.35-1.749.908-3.988 1.313-6.353 1.007-2.365-.305-4.428-1.265-5.889-2.589-.306-.277-.192-1.159.174-1.35 1.75-.908 3.989-1.313 6.354-1.007Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-1st_svg__d)",
    d: "M8.913 26.326c2.53 1.096 4.514 2.824 5.713 4.761.25.406-.158 1.35-.626 1.444-2.234.449-4.851.181-7.38-.915-2.53-1.097-4.513-2.824-5.713-4.762-.25-.405.158-1.349.626-1.443 2.234-.45 4.851-.182 7.38.915Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-1st_svg__e)",
    d: "M8.913 26.326c2.53 1.096 4.514 2.824 5.713 4.761.25.406-.158 1.35-.626 1.444-2.234.449-4.851.181-7.38-.915-2.53-1.097-4.513-2.824-5.713-4.762-.25-.405.158-1.349.626-1.443 2.234-.45 4.851-.182 7.38.915Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-1st_svg__f)",
    d: "M13.467 21.007c1.013 2.564 1.195 5.189.672 7.406-.109.465-1.065.843-1.462.579-1.898-1.262-3.56-3.302-4.572-5.866-1.013-2.564-1.195-5.188-.673-7.406.11-.465 1.066-.842 1.463-.578 1.898 1.262 3.56 3.302 4.572 5.865Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-1st_svg__g)",
    d: "M13.467 21.007c1.013 2.564 1.195 5.189.672 7.406-.109.465-1.065.843-1.462.579-1.898-1.262-3.56-3.302-4.572-5.866-1.013-2.564-1.195-5.188-.673-7.406.11-.465 1.066-.842 1.463-.578 1.898 1.262 3.56 3.302 4.572 5.865Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-1st_svg__h)",
    d: "M9.776 21.106c2.579 2.319 4.255 5.172 4.912 7.963.137.584-.728 1.546-1.324 1.471-2.844-.356-5.859-1.721-8.438-4.04C2.348 24.182.671 21.328.015 18.538c-.138-.584.727-1.546 1.323-1.471 2.844.356 5.859 1.721 8.438 4.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-1st_svg__i)",
    d: "M1.196 21.702c.877 1.708 2.13 3.353 3.73 4.792 2.58 2.318 5.594 3.683 8.438 4.04.596.074 1.46-.887 1.323-1.472-.656-2.79-2.332-5.644-4.911-7.962a16.898 16.898 0 0 0-4.886-3.092l-3.694 3.694Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-1st_svg__j)",
    d: "M31.363 29.632c-2.365.305-4.428 1.266-5.889 2.589-.306.277-.192 1.16.174 1.35 1.75.908 3.989 1.313 6.354 1.007 2.365-.305 4.428-1.265 5.889-2.589.306-.277.192-1.159-.174-1.35-1.75-.908-3.989-1.313-6.354-1.007Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-1st_svg__k)",
    d: "M31.363 29.632c-2.365.305-4.428 1.266-5.889 2.589-.306.277-.192 1.16.174 1.35 1.75.908 3.989 1.313 6.354 1.007 2.365-.305 4.428-1.265 5.889-2.589.306-.277.192-1.159-.174-1.35-1.75-.908-3.989-1.313-6.354-1.007Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-1st_svg__l)",
    d: "M31.087 26.326c-2.53 1.096-4.514 2.824-5.713 4.761-.25.406.158 1.35.626 1.444 2.234.449 4.851.181 7.38-.915 2.53-1.097 4.514-2.824 5.713-4.762.25-.405-.158-1.349-.626-1.443-2.234-.45-4.851-.182-7.38.915Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-1st_svg__m)",
    d: "M31.087 26.326c-2.53 1.096-4.514 2.824-5.713 4.761-.25.406.158 1.35.626 1.444 2.234.449 4.851.181 7.38-.915 2.53-1.097 4.514-2.824 5.713-4.762.25-.405-.158-1.349-.626-1.443-2.234-.45-4.851-.182-7.38.915Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-1st_svg__n)",
    d: "M26.533 21.007c-1.013 2.564-1.195 5.189-.672 7.406.109.465 1.065.843 1.462.579 1.898-1.262 3.56-3.302 4.572-5.866 1.013-2.564 1.195-5.188.673-7.406-.11-.465-1.066-.842-1.463-.578-1.898 1.262-3.559 3.302-4.572 5.865Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-1st_svg__o)",
    d: "M26.533 21.007c-1.013 2.564-1.195 5.189-.672 7.406.109.465 1.065.843 1.462.579 1.898-1.262 3.56-3.302 4.572-5.866 1.013-2.564 1.195-5.188.673-7.406-.11-.465-1.066-.842-1.463-.578-1.898 1.262-3.559 3.302-4.572 5.865Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-1st_svg__p)",
    d: "M30.224 21.106c-2.579 2.319-4.255 5.172-4.912 7.963-.137.584.728 1.546 1.323 1.471 2.845-.356 5.86-1.721 8.439-4.04 2.578-2.318 4.255-5.172 4.911-7.962.138-.584-.727-1.546-1.323-1.471-2.844.356-5.859 1.721-8.438 4.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-1st_svg__q)",
    d: "M38.804 21.702c-.877 1.708-2.13 3.353-3.73 4.792-2.58 2.318-5.594 3.683-8.438 4.04-.596.074-1.461-.887-1.324-1.472.657-2.79 2.333-5.644 4.912-7.962a16.898 16.898 0 0 1 4.886-3.092l3.694 3.694Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-1st_svg__r)",
    d: "M20 40c6.888 0 12.473-5.584 12.473-12.473 0-6.888-5.585-12.472-12.473-12.472-6.889 0-12.473 5.584-12.473 12.472C7.527 34.416 13.111 40 20 40Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-1st_svg__s)",
    d: "M20 37.47c5.49 0 9.942-4.452 9.942-9.942 0-5.491-4.451-9.942-9.942-9.942-5.49 0-9.941 4.45-9.941 9.942 0 5.49 4.45 9.941 9.941 9.941Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-1st_svg__t)",
    d: "M20 36.062a8.535 8.535 0 1 0 0-17.07 8.535 8.535 0 0 0 0 17.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-1st_svg__u)",
    d: "M7.527 27.528C7.527 34.416 13.111 40 20 40c6.888 0 12.473-5.584 12.473-12.472l-.002-.145H7.529l-.002.145Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-1st_svg__v)",
    d: "M23.498 39.505a12.5 12.5 0 0 0 8.342-8.044l-6.075-6.074-1.37.067-3.695-3.696L16.195 32.2l7.303 7.304Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-1st_svg__w)",
    d: "m25.114 24.815-2.446-.59a.94.94 0 0 1-.557-.388l-1.41-2.084a.93.93 0 0 0-.701-.41.929.929 0 0 0-.7.41l-1.41 2.084a.94.94 0 0 1-.558.387l-2.446.591a.94.94 0 0 0-.52 1.49l1.546 1.986a.94.94 0 0 1 .195.65l-.193 2.509a.94.94 0 0 0 1.256.955l2.366-.857a.938.938 0 0 1 .464-.044.939.939 0 0 1 .464.044l2.366.857a.94.94 0 0 0 1.257-.955l-.194-2.51a.94.94 0 0 1 .195-.65l1.547-1.984a.94.94 0 0 0-.52-1.491Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-1st_svg__x)",
    d: "m20.464 31.548 2.366.857a.94.94 0 0 0 1.257-.955l-.194-2.51a.94.94 0 0 1 .195-.65l1.547-1.984a.94.94 0 0 0-.52-1.491l-2.447-.59a.94.94 0 0 1-.557-.388l-1.41-2.084a.93.93 0 0 0-.701-.41v10.16a.938.938 0 0 1 .464.045Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-1st_svg__y)",
    d: "m25.114 24.817-2.446-.591a.939.939 0 0 1-.237-.093l-6.235 8.065c.244.236.613.34.974.21l2.366-.858a.938.938 0 0 1 .464-.044.94.94 0 0 1 .463.044l2.366.857a.94.94 0 0 0 1.257-.956l-.194-2.509a.94.94 0 0 1 .196-.65l1.547-1.984a.94.94 0 0 0-.52-1.491Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-1st_svg__z)",
    d: "m14.886 24.817 2.446-.591a.939.939 0 0 0 .236-.093l6.236 8.065a.935.935 0 0 1-.974.21l-2.366-.858a.938.938 0 0 0-.464-.044.94.94 0 0 0-.464.044l-2.366.857a.94.94 0 0 1-1.257-.956l.194-2.509a.94.94 0 0 0-.195-.65l-1.547-1.984a.94.94 0 0 1 .52-1.491Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-1st_svg__A)",
    d: "M14.235 25.383a.932.932 0 0 0 .13.924l1.547 1.985a.94.94 0 0 1 .195.65l-.194 2.509a.94.94 0 0 0 1.257.955l2.366-.857a.938.938 0 0 1 .464-.044.939.939 0 0 1 .464.044l2.366.857a.94.94 0 0 0 1.257-.955l-.194-2.51a.937.937 0 0 1 .05-.378l-9.709-3.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-1st_svg__B)",
    d: "M25.767 25.383a.932.932 0 0 1-.131.924l-1.547 1.985a.94.94 0 0 0-.195.65l.194 2.509a.94.94 0 0 1-1.257.955l-2.366-.857a.938.938 0 0 0-.464-.044.938.938 0 0 0-.464.044l-2.365.857a.94.94 0 0 1-1.258-.955l.194-2.51a.937.937 0 0 0-.05-.378l9.709-3.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-1st_svg__C)",
    d: "m20 15.055-.155.002-1.925 1.925 14.052 14.051c.325-1.112.5-2.288.5-3.506 0-6.888-5.584-12.472-12.472-12.472Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-1st_svg__D)",
    d: "M12.47.258v6.588l7.53 7.53 7.529-7.53V.258H12.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-1st_svg__E)",
    d: "M12.47.258v2.05l7.504 7.504a.036.036 0 0 0 .05 0l7.505-7.504V.258H12.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-1st_svg__F)",
    d: "M12.47.258v2.05l7.504 7.504a.036.036 0 0 0 .05 0l7.505-7.504V.258H12.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-1st_svg__G)",
    d: "M20 10.996c-.31 0-.621-.119-.857-.355L12.47 3.97v2.874l7.53 7.53 7.529-7.53V3.969l-6.672 6.672a1.208 1.208 0 0 1-.857.355Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-1st_svg__H)",
    d: "M20 10.996c-.31 0-.621-.119-.857-.355L12.47 3.97v2.874l7.53 7.53 7.529-7.53V3.969l-6.672 6.672a1.208 1.208 0 0 1-.857.355Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-1st_svg__I)",
    d: "M20 10.996c.31 0 .62-.119.857-.355l6.672-6.672v2.874l-7.53 7.53-7.529-7.53V3.969l6.673 6.672c.236.236.546.355.857.355Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-1st_svg__J)",
    d: "M19.174 12.666 12.767 6.26a1.23 1.23 0 0 0-1.74 1.74L20 16.972l8.973-8.973a1.23 1.23 0 0 0-1.74-1.74l-6.407 6.407a1.168 1.168 0 0 1-1.652 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-1st_svg__K)",
    d: "m11.027 6.273 8.028 8.029a1.336 1.336 0 0 0 1.89 0l8.028-8.029.007-.007-.007-.007a1.23 1.23 0 0 0-1.74 0l-6.407 6.407a1.168 1.168 0 0 1-1.652 0L12.767 6.26a1.23 1.23 0 0 0-1.74 0l-.006.007.006.007Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-1st_svg__L)",
    d: "m20 16.975 6.334-6.334h-3.48l-2.029 2.028a1.168 1.168 0 0 1-1.651 0l-2.028-2.028h-3.48L20 16.975Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-1st_svg__M)",
    d: "m19.215 16.187.785.784 8.033-8.034h-3.48l-3.728 3.728a1.167 1.167 0 0 1-1.61.038v3.484Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-1st_svg__N)",
    d: "M20 17.843a2.941 2.941 0 1 0 0-5.882 2.941 2.941 0 0 0 0 5.882Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-1st_svg__O)",
    d: "M20 16.591a1.686 1.686 0 1 0 0-3.372 1.686 1.686 0 0 0 0 3.372Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rank-1st_svg__P)",
    d: "M28.667 2.928H11.333a.902.902 0 0 1-.902-.902V.902c0-.498.404-.902.902-.902h17.334c.498 0 .901.404.901.902v1.124a.902.902 0 0 1-.901.902Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-1st_svg__b",
    x1: 5.704,
    x2: 8.292,
    y1: 28.501,
    y2: 32.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-1st_svg__c",
    x1: 5.468,
    x2: 9.546,
    y1: 30.79,
    y2: 32.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-1st_svg__d",
    x1: 3.049,
    x2: 7.323,
    y1: 25.465,
    y2: 28.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-1st_svg__e",
    x1: 4.841,
    x2: 8.083,
    y1: 29.018,
    y2: 28.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-1st_svg__f",
    x1: 11.636,
    x2: 10.656,
    y1: 18.156,
    y2: 22.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-1st_svg__g",
    x1: 7.4,
    x2: 9.91,
    y1: 18.61,
    y2: 21.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-1st_svg__h",
    x1: 5.892,
    x2: 8.049,
    y1: 19.242,
    y2: 25.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-1st_svg__i",
    x1: 6.327,
    x2: 9.098,
    y1: 22.908,
    y2: 25.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-1st_svg__j",
    x1: 34.296,
    x2: 31.708,
    y1: 28.501,
    y2: 32.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-1st_svg__k",
    x1: 34.532,
    x2: 30.454,
    y1: 30.79,
    y2: 32.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-1st_svg__l",
    x1: 36.951,
    x2: 32.677,
    y1: 25.465,
    y2: 28.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-1st_svg__m",
    x1: 35.159,
    x2: 31.917,
    y1: 29.018,
    y2: 28.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-1st_svg__n",
    x1: 28.364,
    x2: 29.344,
    y1: 18.156,
    y2: 22.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-1st_svg__o",
    x1: 32.6,
    x2: 30.09,
    y1: 18.61,
    y2: 21.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-1st_svg__p",
    x1: 34.108,
    x2: 31.951,
    y1: 19.242,
    y2: 25.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-1st_svg__q",
    x1: 33.673,
    x2: 30.902,
    y1: 22.908,
    y2: 25.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-1st_svg__r",
    x1: 12.31,
    x2: 25.464,
    y1: 19.837,
    y2: 32.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-1st_svg__s",
    x1: 26.457,
    x2: 13.355,
    y1: 33.984,
    y2: 20.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-1st_svg__t",
    x1: 13.795,
    x2: 24.008,
    y1: 21.323,
    y2: 31.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-1st_svg__u",
    x1: 20,
    x2: 20,
    y1: 31.177,
    y2: 39.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-1st_svg__v",
    x1: 27.47,
    x2: 17.169,
    y1: 34.012,
    y2: 27.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-1st_svg__w",
    x1: 17.402,
    x2: 22.087,
    y1: 25.154,
    y2: 29.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-1st_svg__x",
    x1: 22.807,
    x2: 16.332,
    y1: 26.432,
    y2: 29.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-1st_svg__y",
    x1: 21.116,
    x2: 17.571,
    y1: 28.732,
    y2: 27.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-1st_svg__z",
    x1: 18.883,
    x2: 22.429,
    y1: 28.732,
    y2: 27.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-1st_svg__A",
    x1: 18.962,
    x2: 21.241,
    y1: 28.909,
    y2: 25.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-1st_svg__B",
    x1: 20.863,
    x2: 20.673,
    y1: 28.446,
    y2: 24.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C3D27",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C3D27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-1st_svg__C",
    x1: 26.146,
    x2: 21.336,
    y1: 22.258,
    y2: 13.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-1st_svg__D",
    x1: 20.557,
    x2: 23.655,
    y1: 4.442,
    y2: 9.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8E8F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-1st_svg__E",
    x1: 17.467,
    x2: 27.088,
    y1: -1.621,
    y2: 9.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4755"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A72B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-1st_svg__F",
    x1: 20,
    x2: 20,
    y1: 5.212,
    y2: 2.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A72B2B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-1st_svg__G",
    x1: 15.424,
    x2: 25.044,
    y1: 0.158,
    y2: 11.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4755"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A72B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-1st_svg__H",
    x1: 22.98,
    x2: 24.319,
    y1: 8.386,
    y2: 9.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A72B2B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-1st_svg__I",
    x1: 17.02,
    x2: 15.681,
    y1: 8.386,
    y2: 9.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A72B2B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-1st_svg__J",
    x1: 26.799,
    x2: 10.716,
    y1: 13.928,
    y2: -2.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-1st_svg__K",
    x1: 20,
    x2: 20,
    y1: 6.403,
    y2: 17.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-1st_svg__L",
    x1: 20,
    x2: 20,
    y1: 12.784,
    y2: 16.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-1st_svg__M",
    x1: 23.707,
    x2: 21.511,
    y1: 10.736,
    y2: 12.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-1st_svg__N",
    x1: 18.313,
    x2: 22.473,
    y1: 13.216,
    y2: 17.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-1st_svg__O",
    x1: 21.647,
    x2: 17.75,
    y1: 16.552,
    y2: 12.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rank-1st_svg__P",
    x1: 20,
    x2: 20,
    y1: 0.889,
    y2: 2.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-rank-1st_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
};
export default SvgIconRank1St;